(function () {
  function mishoPage() {
    const url = window.location.pathname;
    const sp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? true : false;

    // Some sections (ru/special/) on sp are hidden
    if (url === "/en/special/" && sp) {
      const sections = document.querySelectorAll(".special-section");
      const hiddenSections = [0, 1, 3];

      hiddenSections.forEach(i => {
        sections[i].classList.add("is-hidden");

        const btnBox = document.createElement("div");
        btnBox.classList.add("btn__box");
        sections[i].appendChild(btnBox);

        const btn = document.createElement("span");
        btn.classList.add("btn");
        btn.innerHTML = "Read More";
        btnBox.appendChild(btn);

        btn.addEventListener('click', () => {
          if (sections[i].style.maxHeight) {
            sections[i].scrollIntoView({ behavior: "smooth" });
            sections[i].style.maxHeight = null;
            btn.innerHTML = "Read More";
          } else {
            sections[i].style.maxHeight = sections[i].scrollHeight + "px";
            btn.innerHTML = "Close";
          }
          btnBox.classList.toggle("is-transparent");
        })
      });
    }

    // download box hidden on jp version
    if (url === "/special/") {
      const download = document.querySelector(".special-contact__download");
      download.remove();
    }

    // font "Source Han Sans"
    (function(d) {
      var config = {
        kitId: 'mee8ede',
        scriptTimeout: 3000,
        async: true
      },
      h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
    })(document);
  
  }

  const isMishoPage = $(".misho").length;
  if (isMishoPage) {
    mishoPage();
  }
})();
